import $axios from "@/service/httpServer";
// wx.config参数
export const getJsSdkConfig = () => $axios.post('/Web/Backend/WorkWx/jsConfig', {url: location.origin + location.pathname});
// wx.agentConfig参数
export const getJsAgentConfig = p => $axios.post('/Web/Backend/WorkWx/agentConfig', {url: location.origin + location.pathname});

// wx.agentConfig参数
export const getAuthMessage = p => $axios.get('/Web/Backend/WorkWx/getAuthMessage');

export const getAuthType = p => $axios.get('/Web/Backend/WorkWx/getAuthType');

